<style lang="scss" src="./_scss/redeem.scss"></style>
<template>
    <section class="mod_redeem">
        <!-- 成功 -->
        <template v-if="succ">
          <div class="succ_wrap">
              <img src="//puui.qpic.cn/vupload/0/20190514_1557917010779_137y6g0om0uc.png/0" alt="" class="succ_img">
              <div class="txt">{{ $t('兑换成功') }}</div>
          </div>
          <div class="btn_wrap">
            <button class="btn" @click="continueBtnClick"
              v-report="{
                f_hottag: 'mod_redeembtn',
                f_module: '兑换按钮',
                f_type: 3,
                f_resource: '继续兑换',
              }"
            >{{ $t('继续兑换') }}</button>
            <button class="btn launch-btn"
              @click="launchBtnClick"
              v-if="launchBtnVisible"
            >{{ $t('前往WETV享受VIP特权') }}</button>
          </div>
          <div class="qrcode_wrap" v-if="qrcodeVisible">
            <div class="qrcode_title">{{ $t('扫码下载WeTV') }}</div>
            <img src="https://vip.image.video.qpic.cn/vupload/20240517/3160de1715932808233.png" alt="" class="qrcode_img">
          </div>
        </template>
        <template v-else>
          <inputWrap></inputWrap>
          <div class="btn_wrap">
              <!-- 置灰加disabled -->
              <button class="btn" @click="mainBtnClick">{{btnText}}</button>
          </div>
        </template>
    </section>
</template>

<script type="text/ecmascript">
import env from '@tencent/vft-common/env';
import login from '@tencent/wetv-common/login';

import inputWrap from './input-wrap.vue';

export default {
  computed: {
    succ() {
      return this.$store.state.redeem_succ;
    },
    isLogin() {
      return this.$store.state.is_login;
    },
    btnText() {
      if (this.isLogin) {
        if (this.$store.state.phone) {
          return this.$t('立即兑换');
        }
        return this.$t('绑定手机号即可兑换');
      }
      return this.$t('登录即可兑换');
    },
    launchBtnVisible() {
      // 非 wetv 内的 H5 环境显示按钮点击拉起 WeTV
      return !env.isWetv && !env.isWeb;
    },
    qrcodeVisible() {
      // PC Web 场景显示二维码引导用户下载或打开 WeTV
      return env.isWeb;
    },
  },
  methods: {
    async continueBtnClick() {
      this.$store.commit('setState', {
        state: 'redeem_succ',
        value: false,
      });
      this.$store.commit('setState', {
        state: 'reset_flag',
        value: Math.random(),
      });
    },
    async mainBtnClick() {
      if (!this.isLogin) {
        const res = await login.openLogin();
        if (res && !res.errCode) {
          this.$store.dispatch('getUserInfo');
        }
        this.$report.click({
          f_hottag: 'mod_redeembtn',
          f_module: '兑换按钮',
          f_type: 3,
          f_resource: '登录',
        });
        return;
      }
      if (this.$store.state.phone) {
        // 开始兑换
        this.$store.commit('setState', {
          state: 'redeem_flag',
          value: Math.random(),
        });
        this.$report.click({
          f_hottag: 'mod_redeembtn',
          f_module: '兑换按钮',
          f_type: 3,
          f_resource: '开始兑换',
        });
      } else {
        this.toBind();
        this.$report.click({
          f_hottag: 'mod_redeembtn',
          f_module: '兑换按钮',
          f_type: 3,
          f_resource: '绑定手机',
        });
      }
    },
    launchBtnClick() {
      window.location.href = 'https://qqlivei18n.onelink.me/ETTr/VIPredemption';
    },
  },
  components: {
    inputWrap,
  },
};
</script>
